import React from 'react'
import EmailField from 'Event/auth/Login/EmailField'
import Page, {
  StyledPaper,
  StyledFormContainer,
  DescriptionText,
} from 'Event/template/Cards/Login/Page'
import {SignUpProps} from 'Event/auth/SignUp'
import {useCardsTemplate} from 'Event/template/Cards'
import Description from 'Event/auth/SignUp/Description'
import SubmitButton from 'Event/auth/SignUp/SubmitButton'
import {useGuestVariables} from 'Event'
import FirstNameField from 'Event/auth/SignUp/FirstNameField'
import LastNameField from 'Event/auth/SignUp/LastNameField'
import PhoneNumberField from 'Event/auth/SignUp/PhoneNumberField'
import ErrorMessage from 'Event/auth/SignUp/ErrorMessage'
import Visible from 'lib/ui/layout/Visible'

export default function SignUp(props: SignUpProps) {
  return (
    <Page isPreview={false}>
      <StyledPaper>
        <StyledFormContainer>
          <Content {...props} />
        </StyledFormContainer>
      </StyledPaper>
    </Page>
  )
}

export function Content(props: SignUpProps) {
  const {signUp} = useCardsTemplate()
  const v = useGuestVariables()

  return (
    <>
      <Description
        aria-label="event sign up description"
        Component={DescriptionText}
      >
        {v(signUp.description)}
      </Description>
      <form onSubmit={props.onSubmit}>
        <FirstNameField {...props} />
        <LastNameField {...props} />
        <EmailField {...props} />
        <Visible when={signUp.hasPhoneNumberField}>
          <PhoneNumberField {...props} />
        </Visible>
        <ErrorMessage error={props.responseError?.message} />
        <SubmitButton {...props} />
      </form>
    </>
  )
}
